import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import styles from "./DataChartsSection.module.scss"; // SCSS modulunu əlavə et
import chartsData from "../../../../constants/chartsData";
import growth from "../../../../assets/images/pages/infographics/data-charts-section/growth.svg";
import decline from "../../../../assets/images/pages/infographics/data-charts-section/growth-red.svg";
import CountUp from "react-countup";

const DataChartsSection: React.FC = () => {
  const chartOptions: ApexOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      sparkline: { enabled: true },
    },

    fill: {
      type: "solid",
    },
    stroke: { curve: "smooth", width: 2 },
    xaxis: { labels: { show: false }, tooltip: { enabled: false } },
    yaxis: { show: false },
    grid: { show: false },
    tooltip: { enabled: false },
  };

  return (
    <section id={styles.data_charts_section}>
      <div className={styles.section_head}>
        <div className={styles.head_icon}>
          <i className="fa-solid fa-star"></i>
        </div>
        <div className={styles.head_desciption}>
          <h3>Qabaqcıl</h3>
          <p>
            İstənilən məlumatlarını, yeniləmələri və ya statistik məlumatları da
            buraya qoyun
          </p>
        </div>
      </div>
      <div className={styles.data_charts}>
        {chartsData.map((data, index) => (
          <div className={styles.charts_card} key={index}>
            <div className={styles.charts_card_header}>
              <div>
                <h4 className={styles.data_title}>{data.name}</h4>
                <div className={styles.growth}>
                  {data.percentageChange >= 5 ? (
                    <img
                      className={styles.growth_img}
                      src={growth}
                      alt="growth"
                    />
                  ) : (
                    <img
                      className={styles.decline_img}
                      src={decline}
                      alt="decline"
                    />
                  )}
                  <p
                    className={
                      data.percentageChange >= 5
                        ? styles.percentage
                        : styles.percentage_decline
                    }
                  >
                    {data.percentageChange}%
                  </p>
                </div>
              </div>
              <h2 className={styles.data_price}>
                <span>$</span>
                <CountUp duration={6} end={data.price} />
              </h2>
            </div>

            <ReactApexChart
              options={{
                ...chartOptions,
                colors: [data.chartColor],
                fill: {
                  ...chartOptions.fill,
                  gradient: {
                    ...chartOptions.fill?.gradient,
                    gradientToColors: [data.chartColor],
                  },
                },
              }}
              series={[
                {
                  name: "Price",
                  data: data.chartData,
                },
              ]}
              type="area"
              height={180}
              width="100%"
            />

            <div className={styles.charts_card_footer}>
              <span>Ən aşağı: ${data.lowest}</span>
              <span>Ən yüksək: ${data.highest}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DataChartsSection;
